













































import numeral from 'numeral';
import { ref, computed, toRefs, watch, PropType } from '@vue/composition-api';
import { debounce } from 'lodash-es';
import { trackEvent } from './../../../../utils/index';
import { SpuAvailableFilter } from '@tt4b/ttam-enums';
import { i18n } from './../../../../i18n';
import Filter from './filter.vue';
import { spuListAmountType } from '../hooks';

export default {
  components: {
    ProductFilter: Filter,
  },
  props: {
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    total: {
      type: Number,
      default: 0,
    },
    search: {
      type: Object,
      default: () => ({}),
    },
    searchOptions: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Number,
      default: SpuAvailableFilter.AVAILABLE,
    },
    spuListAmount: {
      type: Object as PropType<spuListAmountType>,
      default: () => ({
        allAmount: 0,
        availableAmount: 0,
      }),
    },
  },
  setup(props, ctx) {
    const { total, pageSize, searchOptions, search, spuListAmount } = toRefs(props);
    const selectVal = ref(search.value.field || searchOptions.value?.[0].fieldName);
    watch(
      () => searchOptions.value?.[0].fieldName,
      val => {
        selectVal.value = val;
      },
    );

    const totalFormat = computed(() => numeral(total.value).format('0,0'));
    const pageCount = computed(() => Math.ceil(total.value / pageSize.value));

    const onPageChange = page => {
      ctx.emit('update:page', page);
      trackEvent('module_ad_group_shop_product_select_turn_page');
    };

    const emitChange = ({ value, field }) => {
      ctx.emit('update:search', {
        value,
        field,
      });
    };

    const doSearch = debounce(({ value, field } = {}) => {
      // 更新一下page
      onPageChange(1);
      emitChange({
        value,
        field,
      });
      const optionSel = props.searchOptions.find(option => option.fieldName === field);
      if (optionSel?.track) {
        trackEvent(optionSel.track);
      }
    }, 1000);

    const onInput = val => {
      doSearch({
        value: val,
        field: selectVal.value,
      });
    };

    const onSelectChange = field => {
      const fieldValue = search.value.value;
      if (fieldValue) {
        doSearch({
          value: fieldValue,
          field,
        });
      }
    };

    const searchVal = computed({
      get() {
        return search.value.value;
      },
      set(val) {
        onInput(val);
      },
    });

    const options = computed(() => [
      {
        label: i18n.t('module_common_all'),
        value: SpuAvailableFilter.ALL,
        track: 'module_ad_group_shop_product_filter_click',
        amount: spuListAmount.value.allAmount,
      },
      {
        label: i18n.t('module_common_not_selectable'),
        value: SpuAvailableFilter.AVAILABLE,
        track: 'module_ad_group_shop_product_filter_available_click',
        amount: spuListAmount.value.availableAmount,
      },
    ]);

    const selectFilter = val => {
      ctx.emit('change', val);
    };

    return {
      searchVal,
      selectVal,
      totalFormat,
      pageCount,
      onPageChange,
      onInput,
      onSelectChange,
      options,
      selectFilter,
    };
  },
};
